<div #contentDiv class="max-w-lg mx-auto flex flex-col pt-20 min-h-screen">
  <div class="flex-1 bg-theme-surface rounded-t-3xl h-full p-4 text-theme-text">

    <!-- Tillbaka-knapp och titel -->
    <div class="flex items-center space-x-4">
      <app-circle-button [icon]="'fa-chevron-left'" size="12" type="solid" fontSize="xl" (onClick)="back()">
      </app-circle-button>
      <div class="text-lg text-theme-text font-semibold">{{ getString("Veckans meny") }}</div>
    </div>

    <!-- Bild endast om promoUrl finns -->
    <div *ngIf="promoUrl" class="mt-4">
      <img [src]="promoUrl" class="rounded-lg">
    </div>

    <!-- Veckodagsknappar -->
    <div class="flex justify-between my-4 gap-2">
      <app-tip-button *ngFor="let day of days" [text]="day.name"
        class="flex-grow text-base sm:text-lg"
        [selected]="filterWeekDay === day.ix" (onClick)="showDay(day.ix)">
      </app-tip-button>
    </div>

    <!-- Menykategorier -->
    <div class="px-4" *ngIf="(categories && categories.length > 0); else emptyMenu">
      <div *ngFor="let category of categories">
        <div class="text-3xl px-4 pt-4 font-bold">{{ category.name }}</div>
        <div class="border-b mt-4 border-theme-text3"></div>
        <div>
          <div *ngFor="let item of category.items" class="px-4 py-6">
            <app-menu-item [item]="item" [hidePlusThing]="true"></app-menu-item>
            <ng-container *ngIf="item?.contains?.length">
              <p class="text-sm text-theme-text3 mt-1">
                <i class="fa-solid fa-seedling pr-1"></i>
                <span *ngFor="let contain of item?.contains ?? []; let last = last">
                  {{ contain?.name ?? 'Okänd' }}{{ last ? '' : ', ' }}
                </span>
              </p>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <ng-template #emptyMenu>
      <div class="text-center text-lg text-theme-text2 py-10">
        {{ getString('Veckans meny är tom.') }}
      </div>
    </ng-template>

  </div>

  <div *ngIf="isLoading" class="fixed inset-0 bg-theme-surface-80 bg-opacity-75 flex items-center justify-center z-[100]">
    <app-loading-spinner size="xl"></app-loading-spinner>
  </div>
</div>
